import React from "react";

import InsightKpiCard
from "./InsightKpiCard";


export default function InsightKpiStrip()
{
    const containerStyle =
    {
        width: "100%",

        display: "grid",

        gridTemplateColumns:
            "repeat(6, minmax(0, 1fr))",

        gap: "14px"
    };


    return (

        <div style={containerStyle}>

            <InsightKpiCard

                title="Total Insights"

                value={68}

                percentageChange={8.4}

                comparisonText="month"

                positiveIsGood={false}

            />


            <InsightKpiCard

                title="Critical"

                value={4}

                percentageChange={33.3}

                comparisonText="month"

                positiveIsGood={false}

            />


            <InsightKpiCard

                title="High"

                value={12}

                percentageChange={9.1}

                comparisonText="month"

                positiveIsGood={false}

            />


            <InsightKpiCard

                title="Medium"

                value={21}

                percentageChange={-12.5}

                comparisonText="month"

                positiveIsGood={false}

            />


            <InsightKpiCard

                title="Low"

                value={31}

                percentageChange={6.9}

                comparisonText="month"

                positiveIsGood={true}

            />
			
			
			<InsightKpiCard

               title="AI Confidence"

               value={89}

               percentageChange={-3.9}

               comparisonText="month"

               positiveIsGood={true}

           />

        </div>

    );
}